(function($,window){
		
	function addElementInStack(jsonObject,$par){
		var item = '<li class="item clearfix"  data-index="'+jsonObject.index+'"><div class="item-title">'+jsonObject.titre+'</div><div class="item__buttons"><button class="item-modifier" data-index="'+jsonObject.index+'">Modifier</button><button class="item-supprimer" data-index="'+jsonObject.index+'">Supprimer</button></div></li>';
		$(".stack",$par).append(item);
		$('button.item-modifier[data-index="'+jsonObject.index+'"]').click(function(event){
			event.preventDefault();
			event.stopPropagation();
			var $parent = $(this).parents(".slide-parent");
			var slider =  $.parseJSON($(".slider",$parent).val());
			deserializeMyForm(slider[$(this).attr("data-index")],$parent);
			$(".modifySlide",$parent).attr("data-index",$(this).attr("data-index"));
			return false;
		});
		$('button.item-supprimer[data-index="'+jsonObject.index+'"]').click(function(event){
			event.preventDefault();
			event.stopPropagation();
			var $parent = $(this).parents(".slide-parent");
			var slider =  $.parseJSON($(".slider",$parent).val());
			var index = $(this).attr("data-index");
			deleteSlide(index, slider);
			deleteInStack(index);
			refreshStack(slider);
			$(".slider",$parent).val(JSON.stringify(slider));
			return false;
		});
	}
	
	function initStack(jsonArray,$parent){
		$(".stack",$parent).sortable({});
		$(".stack",$parent).html('');
		$.each(jsonArray,function(idx,elt){
			addElementInStack(elt);
		});
	}
	
	function serializeMyForm($parent){
		var slide = {};
		slide["model"] = $.parseJSON($(".slideModel",$parent).html());
		 $.each($.layoutManagerHandlers.retrieveFieldHandlers(), function (index, fieldHandler) {
             var $inputs = $(fieldHandler.selector, $(".slide-form",$parent));
             $inputs.removeData(['edit-processed','save-processed']);
         });
		 $.each($.layoutManagerHandlers.retrieveFieldHandlers(), function (index, fieldHandler) {
             var $inputs = $(fieldHandler.selector, $(".slide-form",$parent));
             $inputs.each(function () {
                 if (!$(this).data("save-processed")) {
                     if (fieldHandler.save($(this), slide)) {
                         $(this).data("save-processed",true);
                     }
                 }
             });
        });
		var jsonObject = slide["model"];
		var index = $(".stack li.item",$parent).size();
		jsonObject["index"] = index;
		return jsonObject;
	}
	
	function refreshIndex(jsonArray){
		var index = 0;
		$.each(jsonArray,function(idx,elt){
			elt.index=index;
			index++;
		});
	}
	
	function synchronizeIndex(jsonArray,$parent){
		var $ul = $(".stack",$parent);
		var jsonIndexMap  = [];
		//On définit un mapping des nouveaux index
		$("li",$ul).each(function(index,elt){
			jsonIndexMap[$(elt).attr("data-index")]=index;
		});
		//On met à jour les index dans le flux json
		$.each(jsonArray,function(idx,elt){
			var oldIndex = elt.index;
			elt.index = jsonIndexMap[oldIndex];
		});
		var jsonFini = [];
		for(var i =0; i < jsonArray.length; ++i){
			var found = null;
			$.each(jsonArray,function(idx,elt){
				if(elt.index===i){
					found = elt;
				}
			});
			if(found !== null){
				jsonFini[i] = found;
			}
		}
		return jsonFini;
	}

	function refreshStack(jsonArray,$parent){
		refreshIndex(jsonArray);
		initStack(jsonArray,$parent);
	}
	
	function deserializeMyForm(jsonObject,$parent){
		var card = {};
		card["model"] = [];
		for(var name in jsonObject){
			card.model[name] = jsonObject[name];
		}
		$.each($.layoutManagerHandlers.retrieveFieldHandlers(), function (index, fieldHandler) {
	         var $inputs = $(fieldHandler.selector, $(".slide-form",$parent));
	         $inputs.removeData(['edit-processed','save-processed']);
	    });
		$.each($.layoutManagerHandlers.retrieveFieldHandlers(), function (index, fieldHandler) {
	        	var $inputs = $(fieldHandler.selector, $(".slide-form",$parent));
	            $inputs.each(function () {
	                if (!$(this).data("edit-processed")) {
	                    if (fieldHandler.edit($(this), card)) {
	                        $(this).data("edit-processed",true);
	                    }
	                }
	            });
       });
	}
	
	function addToSlider(jsonObject,$parent){
		var slider = $(".slider",$parent).attr('value');
		if(slider === ""){
			slider = "[]";
		}
		var jsonArray = $.parseJSON(slider);
		jsonArray.push(jsonObject);
		$(".slider",$parent).val(JSON.stringify(jsonArray));
	}
	
	function modifySlide(jsonObject,jsonArray){
		jsonArray[jsonObject.index] = jsonObject;
	}
	
	function modifyInStack(jsonObject,$parent){
		$('li[data-index="'+jsonObject.index+'"] .item-title',$parent).html(jsonObject.titre);
	}
	
	function deleteInStack(index){
		$('li[data-index="'+index+'"]').remove();
	}
	
	function deleteSlide(index,jsonArray){
		jsonArray.splice(index,1);
	}
	
	function clearForm($parent){
		$(".slide-form :input",$parent).each(function(idx,elt){
			$(elt).val('');
		});
		resetForm($parent);
	}
	
	function resetForm($parent){
        var $editPanel = $(".slide-form",$parent);
 		var $slideCard = []; 
 		$slideCard.model =	$.parseJSON($(".slideModel",$parent).val());
 		 $.each($.layoutManagerHandlers.retrieveFieldHandlers(), function (index, fieldHandler) {
              var $inputs = $(fieldHandler.selector, $editPanel);
              $inputs.removeData(['edit-processed','save-processed']);
          });
          $.each($.layoutManagerHandlers.retrieveFieldHandlers(), function (index, fieldHandler) {
              var $inputs = $(fieldHandler.selector, $editPanel);
              $inputs.each(function () {
                  if (!$(this).data("edit-processed")) {
                      if (fieldHandler.edit($(this), $slideCard)) {
                          $(this).data("edit-processed",true);
                      }
                  }
              });
          });
	}
	
	
	$(function(){
		 $.layoutManagerHandlers.registerFieldHandler([
               {
                   name: 'slider',
                   selector: 'input[name][type=hidden].slider',
                   edit: function (field, card) {
                	   var $input = $(field);
                	   $input.val(card.model[$input.attr('name')] ? JSON.stringify(card.model[$input.attr('name')]) : '[]');
                       initStack(card.model[$input.attr('name')],$('input[name][type=hidden].slider').parents('.slide-parent'));
                   },
                   save: function (field, card) {
                	   var $input = $(field);
                       if (card.model.hasOwnProperty($input.attr('name'))) {
                    	   if($input.val()){
                    		   var finalJsonArray = synchronizeIndex($.parseJSON($input.val()), $input.parents('.slide-parent'));
                    		   card.model[$input.attr('name')] = finalJsonArray;
                    	   } else {
                    		   card.model[$input.attr('name')] = null;
                    	   }
                           return true;
                       }
                       return false;
                   }
               }]);
		$(".addSlide").click(function(event){
			var $parent = $(this).parents('.slide-parent');
			event.preventDefault();
			var slide = serializeMyForm($parent);
			addToSlider(slide,$parent);
			addElementInStack(slide,$parent);
			clearForm($parent);
		});
		$(".modifySlide").click(function(event){
			var $parent = $(this).parents('.slide-parent');
			event.preventDefault();
			var slider =  $.parseJSON($(".slider",$parent).val());
			var jsonChanged = serializeMyForm($parent);
			var index = $(this).attr("data-index");
			jsonChanged["index"] = index;
			modifySlide(jsonChanged,slider);
			modifyInStack(jsonChanged,$parent);
			$(".slider",$parent).val(JSON.stringify(slider));
			clearForm($parent);
		});
	});


})(jQuery.noConflict(),window);
